import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromFilter, updateFilter } from "../../store/slices/filterSlice";

const Clarity = () => {
  const clarityRange = [
    { label: "IF", value: "IF" },
    { label: "FL", value: "FL" },
    { label: "VVS1", value: "VVS1" },
    { label: "VVS2", value: "VVS2" },
    { label: "VS1", value: "VS1" },
    { label: "VS2", value: "VS2" },
    { label: "SI1", value: "SI1" },
    { label: "SI2", value: "SI2" },
    { label: "I1", value: "I1" },
    { label: "I2", value: "I2" },
    { label: "I3", value: "I3" },
  ];
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value) => {
    dispatch(updateFilter({ key: "clarity", value: value }));
  };
  const handleRemoveFilter = (value) => {
    dispatch(removeFromFilter({ key: "clarity", value: value }));
  };
  return (
    <div className="w-100">
      <label className="filter-main-label">Clarity</label>
      <div className="filter-bg-container clarity-range range-outer-container">
        {clarityRange.map((item) => {
          return (
            <div
              className={`range-item ${
                filterSelect?.clarity?.includes(item?.value) ? "active" : ""
              }`}
              onClick={() =>
                filterSelect?.clarity?.includes(item?.value)
                  ? handleRemoveFilter(item?.value)
                  : handleAddFilter(item?.value)
              }
            >
              {item?.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Clarity;
